import React from 'react';
import Txt from './Txt';
import Button from './Button';
import Dialog from './Dialog';
import CookieBannerDialog from './CookieBannerDialog';
import { useTheme } from 'styled-components';
import { Box, BoxProps } from '@mui/material';

const CookiesDisabled = (props: BoxProps): JSX.Element => {
	const theme = useTheme();

	const handleChangeCookieSettings = React.useCallback(async () => {
		if (document.requestStorageAccess) {
			//Safari in an iframe might need to request storage access for third party cookies
			await document.requestStorageAccess();
		}
		Dialog.render({
			renderContent: CookieBannerDialog,
		});
	}, []);

	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			bgcolor={theme.customColors.decentBlue}
			p="2rem"
			border="1px solid black"
			{...props}
		>
			<Txt align="center">
				Zur Darstellung des Inhalts sind Cookies externer Drittsysteme erforderlich. Akzeptiere in
				den Einstellungen die Cookies &quot;Externe Drittsysteme&quot;, um den Inhalt darstellen zu
				können.
			</Txt>
			<Button m="1rem 0 0 0" variant="secondButton" onClick={handleChangeCookieSettings}>
				Cookie-Einstellungen ändern
			</Button>
		</Box>
	);
};

export default React.memo(CookiesDisabled);
